// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__wn-iF","approved":"Status_approved__2vtFj","rejected":"Status_rejected__2jdkX","expired":"Status_expired__xFq21","label":"Status_label___GAOw"};